import { render, staticRenderFns } from "./InvoicesValidations.vue?vue&type=template&id=23402f5b"
import script from "./InvoicesValidations.vue?vue&type=script&lang=js"
export * from "./InvoicesValidations.vue?vue&type=script&lang=js"
import style0 from "./InvoicesValidations.vue?vue&type=style&index=0&id=23402f5b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports